
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import SPUService from '@/services/spu.service';
import lazyInject from '@/di';
import CategoryImagesField from '@/components/spu/fields/CategoryImagesField.vue';
import draggable from 'vuedraggable';
import { v4 } from 'uuid';

// 定义接口（建议）
// interface PhotoResource {
//   name: string;
//   _error?: boolean; // 标记是否校验失败
// }

// interface Item {
//   photo_resource_info: PhotoResource[];
// }

/**
 * 校验所有 name 字段，并在不符合的 resource 上设置 _error = true
 * @param items 待校验的数据（通常来自 this.formData）
 * @returns 是否全部有效
 */
function validatePhotoNamesAndMarkErrors(vm: Vue, items: unknown): any {
  // 类型守卫：确保是数组
  if (!Array.isArray(items)) {
    return false;
  }

  let allValid = true;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    // 跳过非对象项（不中断，继续校验其他）
    if (!item || typeof item !== 'object') {
      allValid = false;
      continue;
    }

    const photoResources = (item as Record<string, unknown>)
      .photo_resource_info;

    // 若 photo_resource_info 不是数组，跳过该项
    if (!Array.isArray(photoResources)) {
      allValid = false;
      continue;
    }

    // 遍历每个 resource
    for (let j = 0; j < photoResources.length; j++) {
      const resource = photoResources[j];
      let isValid = true;

      if (
        !resource ||
        typeof resource !== 'object' ||
        typeof (resource as any).name !== 'string' ||
        (resource as any).name.trim() === ''
      ) {
        isValid = false;
        allValid = false;
      }

      // 关键：标记 _error 状态
      // 注意：在 Vue 2 中，若 _error 是动态添加的，需用 $set 才能响应式
      // 此处假设调用方会处理响应式（如通过 this.$set 或初始化包含 _error）
      vm.$set(resource, '_error', !isValid);
    }
  }
  return allValid;
}

@Component({
  components: {
    CategoryImagesField,
    draggable,
  },
})
export default class UploadImageModal extends Vue {
  @lazyInject(SPUService)
  protected spuService!: SPUService;

  visible = false;

  visibleModal = false;

  labelCol = { span: 6 };

  wrapperCol = { span: 12 };

  categoryName = '';

  upDate: any = [{ imgs: [] }, { imgs: [] }, { imgs: [] }];

  uuid = v4;

  @Ref('formModel')
  formModel!: FormModel;

  @Prop({ default: () => [] })
  categoryPhotoList!: any;

  titleText = '上传图片';

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  form: any = {
    poi: '',
    city_code: undefined,
    address: '',
    market_name: '',
  };

  rules: any = {
    poi: [{ required: true, message: '请输入图片分类名称', trigger: 'blur' }],
  };

  columns = [
    {
      title: '商品类目',
      dataIndex: 'categoryName',
      key: 'categoryName',
      align: 'center',
      scopedSlots: { customRender: 'categoryName' },
    },
    {
      title: '图片分类名称',
      dataIndex: 'photo_type_name',
      key: 'photo_type_name',
      align: 'center',
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
    },
    {
      title: '创建人',
      dataIndex: 'operator_name',
      key: 'operator_name',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];

  data = [];

  viewImageSource = '';

  viewImageVisible = false;

  viewImage(src: string) {
    this.viewImageSource = src;
    this.viewImageVisible = true;
  }

  updateImg(val: any, index: number) {
    // console.log(val, index);
    const update = this.upDate;
    update[index].photo_resource_info = val;
    this.$set(this, 'upDate', update);
    // console.log(this.upDate);
  }

  onChangePage(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
  }

  addImageManagement() {
    // console.log('新增分类');
    this.visibleModal = true;
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
  }

  init() {
    // this.visible = val;
    this.titleText = '上传图片';
    this.visible = true;
    this.upDate = this.categoryPhotoList.map((item: any) => {
      return {
        photo_type_id: item.id,
        photo_type_name: item.photo_type_name,
        photo_resource_info: [],
      };
    });
    // console.log(this.upDate);
    // this.getPhotoList();
  }

  deleteImg(index: number, id: any) {
    const update = this.upDate;
    const photoResourceInfo = update[index].photo_resource_info;
    update[index].photo_resource_info = photoResourceInfo.filter(
      (item: any) => item.resource_id !== id,
    );
    this.$set(this, 'upDate', update);
  }

  onClose() {
    this.visible = false;
  }

  async onSubmit() {
    if (validatePhotoNamesAndMarkErrors(this, this.upDate)) {
      const form = this.upDate.filter(
        (item: any) => item.photo_resource_info.length > 0,
      );
      const res = await this.spuService.postCategoryPhotoResourceEdit(form);
      if (res) {
        this.$message.success('创建成功');
        this.$emit('upload');
        this.onClose();
      }
    }
  }

  handleOk() {
    this.formModel.validate((valid: boolean) => {
      if (valid) {
        this.visibleModal = false;
      } else {
        return false;
      }
    });
  }

  handleCancel() {
    this.visibleModal = false;
  }
}
